import { declareString } from "@1js/localization";

export const DetailProductDescription = declareString(
  "promptLibrary.promptDetailProductDescription",
  {
    text: "Works in",
    comment: `Description that appears next to product badges in prompt detail. The description category is appended with one or more product names for which the Copilot prompt would work. e.g.: "Works in Microsoft 365 Chat, Word"`,
  }
);

export const DetailProductDescriptionAlsoWorksIn = declareString(
  "promptLibrary.promptDetailProductDescriptionAlsoWorksIn",
  {
    text: "Also works in",
    comment: `Description that appears next to product badges in prompt detail. The description category is appended with one or more product names for which the Copilot prompt can be tried in. e.g.: "Works also in Microsoft 365 Chat, Word"`,
  }
);

export const DetailProductDescriptionAlsoWorksInInfoLabel = declareString(
  "promptLibrary.promptDetailProductDescriptionAlsoWorksInInfoLabel",
  {
    text: "In some apps, you’ll need to copy and paste the prompt into Copilot.",
    comment: `Info label displayed next to DetailProductDescriptionAlsoWorksIn when user clicks on an Info-button.`,
  }
);

export const DetailDisplayCategoryDescription = declareString(
  "promptLibrary.promptDetailDisplayCategoryDescription",
  {
    text: "Category",
    comment: `Description that appears when the user opens a Prompt. The category label will be found next to the category related to that prompt (e.g.: Create, Edit, Catch up, etc.).`,
  }
);

export const CloseTooltip = declareString("promptLibrary.closeTooltip", {
  text: "Close",
  comment: `Tooltip that appears when the user hovers close buttons in prompt details page.`,
});

export const ExtensionPromptDescriptionInfoLabel = declareString(
  "promptLibrary.ExtensionPromptDescriptionInfoLabel",
  {
    text: 'After pasting the prompt into Copilot type "@" and choose the extension name before submitting it.',
    comment: `Info label displayed next to DetailProductDescriptionAlsoWorksIn when user clicks on an Info-button for extention prompt.`,
  }
);
